import { AppProps } from 'next/app'
import { Composable } from '@modules/oriuminc/base'
import { CommercetoolsProvider } from '@modules/commercetools'
import { theme } from '@modules/chakra'
import { carouselExtendedTheme } from '@spoonflower/carousel'
import {
  Layout,
  intlConfig,
  COMMERCETOOLS_CLIENT_ID,
  COMMERCETOOLS_CLIENT_SECRET,
  COMMERCETOOLS_HOST,
  COMMERCETOOLS_PROJECT_KEY,
  BRAND_NAME,
  ErrorBoundary,
} from '@modules/app'
import { UIProvider } from '@spoonflower/ui'
import { ToastProvider } from '@modules/ui/providers/ToastProvider'
import { ExperimentProvider } from '@modules/ui/providers/Experiment/ExperimentProvider'

const extendedTheme = {
  ...theme,
  components: {
    ...theme.components,
    Progress: carouselExtendedTheme.components.Progress,
    Carousel: carouselExtendedTheme.components.Carousel,
  },
}

const App = ({ Component, pageProps }: AppProps) => {
  return (
    <ErrorBoundary>
      <UIProvider>
        <ExperimentProvider>
          <ToastProvider>
            <Composable
              pageProps={pageProps}
              intl={intlConfig}
              theme={extendedTheme}
              appKey={BRAND_NAME}
            >
              <CommercetoolsProvider
                clientId={COMMERCETOOLS_CLIENT_ID}
                clientSecret={COMMERCETOOLS_CLIENT_SECRET}
                host={COMMERCETOOLS_HOST}
                projectKey={COMMERCETOOLS_PROJECT_KEY}
              >
                <Layout>
                  <Component {...pageProps} />
                </Layout>
              </CommercetoolsProvider>
            </Composable>
          </ToastProvider>
        </ExperimentProvider>
      </UIProvider>
    </ErrorBoundary>
  )
}

export default App
